import React, { useState, useRef, useEffect } from "react";
import ic_remove_item from "../img/ic_remove_item.png";
import axios from "axios";
import ic_barcode_symbol from "../img/ic_barcode_symbol.png";
import ic_loader from "../img/ic_loader_get_last_price.png";

function MakeOrderPageListContainer(props) {

    const { toggleBarcodeScannerView, currentResultOfBarcode, idOfRowInListOfScanBarcode } = props


    const [updatedObjectWithLastCustomerSellingPrice, setUpdatedObjectWithLastCustomerSellingPrice] = useState();
    const [isCallingLastCustomerSellingPrice, setIsCallingLastCustomerSellingPrice] = useState(false);
    const [itemCodeAlreadyPresentPopup, setItemCodeAlreadyPresentState] = useState(false);
    const [isCallingApi, setIsCallingApi] = useState(false);
    const timeInterval = useRef(null);
    const currentItemSearchBoxParentId = useRef(0);

    const { fullObject, deleteItemFromParent } = props;
    const order_items_array = fullObject.order_items_array;
    const { sendClickedRowIteObjectToParent, sendClickedRowIteObjectToParentLastCustomerPrice } = props;
    const [arrayOfSearchResultsItems, setArrayOfSearchResultsItems] = useState([]);
    const [showHideSearchListBox, setShowHideSearchListBox] = useState(false);

    console.log("inside MakeOrderPageListContainer ", order_items_array);

    if (order_items_array.length > 0) {
        console.log("inside MakeOrderPageListContainer order_items_array.length > 0 func")
        localStorage.setItem("cubix_order_taking_currentOrder", JSON.stringify(fullObject));
    }



    const handleInputItemName = (e) => {

        console.log("e.target.getAttribute", e.target.getAttribute("data-searchbox-parent-id"));
        currentItemSearchBoxParentId.current = e.target.getAttribute("data-searchbox-parent-id");

        let updatedObjectWithSearchedItemNameInput = { ...order_items_array[e.target.getAttribute("data-searchbox-parent-id") - 1], item_name: e.target.value, item_code: "no item code" }

        sendClickedRowIteObjectToParent(e.target.getAttribute("data-searchbox-parent-id"), updatedObjectWithSearchedItemNameInput);

        clearInterval(timeInterval.current);

        timeInterval.current = setTimeout(() => {
            if (e.target.value.length > 0) {

                console.log(" searchtext changed is", e.target.value);
                if (timeInterval) {
                    console.log("timer is not null we are clearing it")
                    clearInterval(timeInterval);
                }

                // setShowHideSearchListBox(true);
                setIsCallingApi(true);
                setArrayOfSearchResultsItems([]);

                callApi(e.target.value);

            } else {
                setShowHideSearchListBox(false);
            }
        }, 500)

    }

    const handleInputItemNameAfterBarcodeScan = ( resultofbarcode) => {

        console.log("currentItemSearchBoxParentId.current result", currentItemSearchBoxParentId.current, resultofbarcode);


        let updatedObjectWithSearchedItemNameInput = { ...order_items_array[currentItemSearchBoxParentId.current - 1], item_name: resultofbarcode, item_code: "no item code" }

        sendClickedRowIteObjectToParent(currentItemSearchBoxParentId.current, updatedObjectWithSearchedItemNameInput);

        setIsCallingApi(true);
        setArrayOfSearchResultsItems([]);

        callApi(resultofbarcode);

    }

    useEffect(() => {

        console.log("currentResultOfBarcode in list",  currentResultOfBarcode)
        if (currentResultOfBarcode) {
            handleInputItemNameAfterBarcodeScan( currentResultOfBarcode)
        }


    }, [currentResultOfBarcode])

    const handleInputQuantity = (e) => {
        console.log("input qty row id ", e.target.getAttribute("data-searchbox-parent-id"));

        let updatedObjectWithQuantityWithItemQuantity = { ...order_items_array[e.target.getAttribute("data-searchbox-parent-id") - 1], item_qty: Number(e.target.value) };
        sendClickedRowIteObjectToParent(e.target.getAttribute("data-searchbox-parent-id"), updatedObjectWithQuantityWithItemQuantity);
    }

    const handleInputUnitPrice = (e) => {
        console.log("input qty row id ", e.target.getAttribute("data-searchbox-parent-id"));

        let updatedObjectWithQuantityWithItemQuantity = { ...order_items_array[e.target.getAttribute("data-searchbox-parent-id") - 1], item_price: Number(e.target.value) };
        sendClickedRowIteObjectToParent(parseInt(e.target.getAttribute("data-searchbox-parent-id")), updatedObjectWithQuantityWithItemQuantity);
    }

    const handleInputItemRemark = (e) => {
        console.log("input qty row id inside handleInputItemRemark", e.target.getAttribute("data-searchbox-parent-id"));

        let updatedObjectWithQuantityWithItemRemark = { ...order_items_array[e.target.getAttribute("data-searchbox-parent-id") - 1], itemwiseRemark: e.target.value };
        sendClickedRowIteObjectToParent(parseInt(e.target.getAttribute("data-searchbox-parent-id")), updatedObjectWithQuantityWithItemRemark);
    }

    const clickedItemFromSearchList = (e, ind) => {
        e.stopPropagation();
        console.log("clicked on ", e.target);
        console.log("clicked on  id", e.target.getAttribute("data-searchbox-parent-id"));
        console.log("clicked on search list row index", ind);

        let ObjectToSendAfterSearch = {
            ...order_items_array[e.target.getAttribute("data-searchbox-parent-id") - 1],
            item_name: arrayOfSearchResultsItems[ind].Description,
            item_code: arrayOfSearchResultsItems[ind].Code,
            item_price: arrayOfSearchResultsItems[ind].price,
            item_qty: order_items_array[e.target.getAttribute("data-searchbox-parent-id") - 1].item_qty,

            itemwiseRemark: order_items_array[e.target.getAttribute("data-searchbox-parent-id") - 1].itemwiseRemark,
            BarcodeRemark: arrayOfSearchResultsItems[ind].Barcode,


            item_unit: arrayOfSearchResultsItems[ind].unit,

            item_unit_price_static: arrayOfSearchResultsItems[ind].price,
        }

        // qty not related to search of product from API, so save previous item_qty received from MakeOrderPage props

        //sendClickedRowIteObjectToParent(e.target.getAttribute("data-searchbox-parent-id"), arrayOfSearchResultsItems[ind]);

        const checkIfItemCodeAlreadyExistsArray = order_items_array.filter((arrayItem) => {
            return arrayItem.item_code == ObjectToSendAfterSearch.item_code;
        })
        if (checkIfItemCodeAlreadyExistsArray.length > 0) {
            setShowHideSearchListBox(false);
            showHideItemCodeAlreadyPresentPopup();

        } else {
            sendClickedRowIteObjectToParent(e.target.getAttribute("data-searchbox-parent-id"), ObjectToSendAfterSearch);
            // so send that updatedobject instead of  arrayOfSearchResultsItems[ind] because in that Code, Description, price is the key name , so that will not match with item_code, item_description, item_price
            setShowHideSearchListBox(false);

            // now call api to get LastCustomerSellingPrice
            getLastCustomerSellingPrice(e, arrayOfSearchResultsItems[ind].Code)
        }

    }

    const callApi = (searchingText) => {
        axios.get(`${process.env.REACT_APP_BASE_URL}/Search_Items/Sitem/${searchingText}`).then((res) => {
            console.log(" res is ", res);

            setIsCallingApi(false);

            if (res.data != null) {
                if (res.data.result.length > 0) {
                    setShowHideSearchListBox(true);
                    setArrayOfSearchResultsItems(res.data.result);
                } else {
                    setShowHideSearchListBox(false);
                }
            } else {
                setShowHideSearchListBox(false);
                console.log("res.data is null", res);
            }


        }).catch(err => console.log("error is ", err))
    }

    const deleteItemFromRow = (e) => {

        console.log("id of row to delete", e.target.getAttribute("data-searchbox-parent-id"));
        deleteItemFromParent(e.target.getAttribute("data-searchbox-parent-id"));
    }

    const showHideItemCodeAlreadyPresentPopup = () => {
        setItemCodeAlreadyPresentState(prev => !prev);
    }

    const getLastCustomerSellingPrice = (e, product_code) => {


        setIsCallingLastCustomerSellingPrice(true);

        const user_account_number = fullObject.company_account_number;

        axios.get(`${process.env.REACT_APP_BASE_URL}/Search_Items/lastsellprice?code=${product_code}&custacount=${user_account_number}`).then((res) => {

            setIsCallingLastCustomerSellingPrice(false);

            console.log(" res is ", res);

            console.log("e from which getLastCustomerSellingPrice is called and code ", e.target, product_code)

            let thePriceToBePutInTheField = null;
            if (res.data.result1 != null) {
                thePriceToBePutInTheField = res.data.result1[0].lastsellprice;
            }

            console.log(" thePriceToBePutInTheField is ", thePriceToBePutInTheField);

            if (thePriceToBePutInTheField != null) {
                setUpdatedObjectWithLastCustomerSellingPrice({ item_code: product_code, last_price: thePriceToBePutInTheField });
                console.log("before setting updatedObjectWithLastCustomerSellingPrice ", updatedObjectWithLastCustomerSellingPrice);

            }

        }).catch(err => {
            setIsCallingLastCustomerSellingPrice(false);
            console.log("error is ", err);
        })
    }


    useEffect(() => {

        if (order_items_array != null) {

            if (updatedObjectWithLastCustomerSellingPrice != null) {
                order_items_array.forEach((item) => {

                    console.log("checkinng order_items_array forech item ", item)
                    console.log("checkinng order_items_array updatedObjectWithLastCustomerSellingPrice ", updatedObjectWithLastCustomerSellingPrice)

                    if (item.item_code == updatedObjectWithLastCustomerSellingPrice.item_code) {
                        console.log("successs updatedObjectWithLastCustomerSellingPrice is ", updatedObjectWithLastCustomerSellingPrice);
                        sendClickedRowIteObjectToParentLastCustomerPrice(updatedObjectWithLastCustomerSellingPrice);
                    }
                })
            } else {
                console.log("updatedObjectWithLastCustomerSellingPrice is null");
            }
        }

    }, [updatedObjectWithLastCustomerSellingPrice])

    return (
        <div className="MakeOrderPage-list-container">

            {
                order_items_array != null ?
                    order_items_array.map((parent_item) => {

                        return (
                            <div className="MakeOrderPage-list-row mt-2" id={parent_item.id}>

                                {
                                    parent_item.item_code.length > 0 ?
                                        <span className="MakeOrderPage-list-row-item-code">{parent_item.item_code}</span>
                                        :
                                        <span className="MakeOrderPage-list-row-item-code">{""}</span>
                                }


                                <div className="MakeOrderPage-list-row-top-section" >
                                    <input autoComplete="off" className="MakeOrderPage-list-row-top-item-name mt-2" placeholder="Item name" value={parent_item.item_name} data-searchbox-parent-id={parent_item.id} type="text" onChange={(e) => { handleInputItemName(e) }} />
                                    <button onClick={() => {currentItemSearchBoxParentId.current=parent_item.id; toggleBarcodeScannerView(parent_item.id) }}>Scan barcode</button>
                                </div>
                                {(isCallingApi && currentItemSearchBoxParentId.current == parent_item.id) && <div><span>Searching for item ...</span></div>}

                                {console.log("currentItemSearchBoxParentId.current ", currentItemSearchBoxParentId.current,)}
                                {(showHideSearchListBox && currentItemSearchBoxParentId.current == parent_item.id) &&

                                    <div className="MakeOrderPage-search-list-container-top" id={parent_item.id}>

                                        <table className="CheckStockPage_SearchResultListContainer-table">
                                            <thead>
                                                <tr>
                                                    <th>Code</th>
                                                    <th>Description</th>
                                                    {/* <th>Qty</th>
                                                    <th>Order Pending</th> */}
                                                    <th>Qty</th>
                                                    <th>Price</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {arrayOfSearchResultsItems != null ?
                                                    arrayOfSearchResultsItems.length > 0 ?
                                                        arrayOfSearchResultsItems.map((item, index) => {

                                                            return (<tr key={item.Code} id={item.Code} className="CheckStockPage_SearchResultListContainer_single_list_item" >
                                                                <td >
                                                                    <div data-searchbox-parent-id={parent_item.id} onClick={(e) => clickedItemFromSearchList(e, index)}>
                                                                        {item.Code}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className="MakeOrderPageListContainer-barcode-container" data-searchbox-parent-id={parent_item.id} onClick={(e) => clickedItemFromSearchList(e, index)}>
                                                                        {item.Description}

                                                                        {
                                                                            (item.Barcode == "0" || item.Barcode.length == 0) ?
                                                                                null
                                                                                :
                                                                                <span className="mt-2">
                                                                                    <label className="MakeOrderPageListContainer-barcode-label me-2">Barcode </label>
                                                                                    <label className="MakeOrderPageListContainer-barcode-value">{item.Barcode}</label>
                                                                                </span>

                                                                        }

                                                                    </div>
                                                                </td>
                                                                {/* <td>
                                                                    <div data-searchbox-parent-id={parent_item.id} onClick={(e) => clickedItemFromSearchList(e, index)}>
                                                                        {item.Qty}
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <div data-searchbox-parent-id={parent_item.id} onClick={(e) => clickedItemFromSearchList(e, index)}>
                                                                        {item.Ord_pend}
                                                                    </div>
                                                                </td> */}

                                                                <td>
                                                                    <div data-searchbox-parent-id={parent_item.id} onClick={(e) => clickedItemFromSearchList(e, index)}>
                                                                        {item.Qty}
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <div data-searchbox-parent-id={parent_item.id} onClick={(e) => clickedItemFromSearchList(e, index)}>
                                                                        {item.price}
                                                                    </div>
                                                                </td>

                                                            </tr>)

                                                        })
                                                        : null
                                                    : null}

                                            </tbody>
                                        </table>

                                    </div>
                                }

                                <div className="MakeOrderPage-list-row-bottom-section">

                                    <div className="MakeOrder-qty-unit-price-container">
                                        <span className="MakeOrderPage-list-row-bottom-item-qty-span">
                                            <small>Qty </small>
                                            <input autoComplete="off" className="MakeOrderPage-list-row-bottom-item-qty" type="number" data-searchbox-parent-id={parent_item.id} value={parent_item.item_qty} onChange={handleInputQuantity} />
                                        </span>
                                        <label className="MakeOrderPage-list-row-bottom-section-label-unit-price">
                                            <small>Unit price </small>
                                            {/* <span>{parent_item.item_price}</span> */}
                                            {/* <input autoComplete="off" className="MakeOrderPage-list-row-bottom-item-qty" type="number" data-searchbox-parent-id={parent_item.id} value={parent_item.item_price} onChange={handleInputUnitPrice} /> */}
                                            <label > {parent_item.item_unit_price_static} </label>
                                        </label>
                                    </div>

                                    <div>
                                        <small>Last Customer Selling Price</small>
                                        <input autoComplete="off" className="MakeOrderPage-list-row-bottom-item-qty" type="number" data-searchbox-parent-id={parent_item.id} value={parent_item.item_price} onChange={handleInputUnitPrice} />
                                    </div>

                                    <div className="MakeOrder-item-remark-and-barcode-container">
                                        <label className="mt-2">Item Remark </label>
                                        <input autoComplete="off" className="MakeOrder-remark-and-barcode-input" type="text" data-searchbox-parent-id={parent_item.id} value={parent_item.itemwiseRemark} onChange={handleInputItemRemark} />
                                        <label className="mt-2">Item Barcode </label>

                                        {
                                            (parent_item.BarcodeRemark == "0" || parent_item.BarcodeRemark == 0) ?
                                                <p>No barcode</p>
                                                :
                                                <span>

                                                    <label className="mt-2">{parent_item.BarcodeRemark} </label>
                                                </span>
                                        }

                                    </div>

                                    <div className="MakeOrder-total-of-single-item-container">
                                        <label className="MakeOrderPage-list-row-bottom-section-label-total">
                                            <small>Total</small>
                                            <span className="MakeOrderPage-single-item-total-value">{Math.round((parent_item.item_price * parent_item.item_qty) * 100) / 100}</span>
                                        </label>
                                    </div>

                                    <img className="MakeOrderPage-list-row-bottom-section-delete" src={ic_remove_item} onClick={deleteItemFromRow} data-searchbox-parent-id={parent_item.id} />

                                </div>

                                {
                                    itemCodeAlreadyPresentPopup &&
                                    <div className="MakeOrder-CustomerEmpty-Popup-root-container">

                                        <div className="MakeOrder-CustomerEmpty-Popup-root-container-child card">

                                            <div>
                                                Item is already present in the list.
                                            </div>
                                            <div className="MakeOrder-CustomerEmpty-Popup-child-button-container mt-4">
                                                <button onClick={showHideItemCodeAlreadyPresentPopup}>OK</button>

                                            </div>
                                        </div>
                                    </div>
                                }

                            </div>
                        )
                    })
                    :
                    <div> no data</div>

            }

            {isCallingLastCustomerSellingPrice &&

                <div className="MakeOrder-calling-last-customer-price-root-container">
                    <div className="MakeOrder-calling-last-customer-price-inner-container">
                        <img src={ic_loader} />
                        <p className="mt-2 ms-2">Please Wait, Fetching last customer selling price ... </p>
                    </div>
                </div>
            }



        </div>
    )
}

export default MakeOrderPageListContainer;